import { defineStore } from 'pinia';
import type { OutboundDelivery } from '../domain/outboundDelivery';
import { useEntityStore } from 'shared/common/composables/entityStore';
import { computed } from 'vue';

export const useOutboundDeliveryStore = defineStore('outbound-deliveries', () => {
  const { add, clear, getById, merge, remove, list, changed } = useEntityStore<OutboundDelivery>({
    eventName: 'outbound-delivery-changed',
    getEntityId: (e) => e.id,
    updateEntity: (dest, src) => {
      dest.name = src.name;
      dest.customer = src.customer;
      dest.customerReference = src.customerReference;
      dest.note = src.note;
      dest.status = src.status;
      dest.plannedStartUtc = src.plannedStartUtc;
      dest.plannedFinishUtc = src.plannedFinishUtc;
      dest.actualStartUtc = src.actualStartUtc;
      dest.actualFinishUtc = src.actualFinishUtc;
      dest.createdAtUtc = src.createdAtUtc;
      dest.rows = src.rows;
    },
  });

  return {
    add,
    clear,
    getById,
    merge,
    remove,
    list: computed(() => list.value),
    changed,
  };
});
